import { createSelector } from '@ngrx/store';
import { IAppState } from 'app/IAppState';
import { SecurityAuthenticationState } from '../../core/authentication-contracts';

const authenticationSelector = (state: IAppState) =>
  state.securityAuth.authentication;

export const isLoading = createSelector(
  authenticationSelector,
  (state: SecurityAuthenticationState) => state.isLoading
);

export const getMetadata = createSelector(
  authenticationSelector,
  (state: SecurityAuthenticationState) => state.metadata
);

export const getAuthenticationData = createSelector(
  authenticationSelector,
  (state: SecurityAuthenticationState) => state.authenticationData
);

export const isAvailableToEdit = createSelector(
  authenticationSelector,
  (state: SecurityAuthenticationState) => state.isAvailableForChanges
);

export const isValid = createSelector(
  authenticationSelector,
  (state: SecurityAuthenticationState) => state.authenticationIsValid
);

export const selectedAuthenticator = createSelector(
  authenticationSelector,
  (state: SecurityAuthenticationState) => state.selectedAuthenticator
);

export const currentOption = createSelector(
  authenticationSelector,
  (state: SecurityAuthenticationState) => state.currentOption
);

export const multipleViewMode = createSelector(
  authenticationSelector,
  (state: SecurityAuthenticationState) => state.multipleViewMode
);

export const multipleMethods = createSelector(
  authenticationSelector,
  (state: SecurityAuthenticationState) => state.authenticatorList
);

export const multipleOptions = createSelector(
  authenticationSelector,
  (state: SecurityAuthenticationState) => state.multipleOptions
);

export const currentAuthenticator = createSelector(
  authenticationSelector,
  (state: SecurityAuthenticationState) => state.currentAuthenticator
);

export const currentAuthenticatorOptionsMetadata = createSelector(
  authenticationSelector,
  (state: SecurityAuthenticationState) => state.currentAuthenticatorOptionsMetadata
);

export const multipleOptionsDefaultValues = createSelector(
  authenticationSelector,
  (state: SecurityAuthenticationState) => state.multipleOptionsDefaultValues
);
